// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__hm6ty","cell":"ColumnAccessor_cell__2208T","firstCellAccent":"ColumnAccessor_firstCellAccent__2doVt"};